import { takeLatest, call, put, all, select } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, postApi } from 'services/rotasp/api';

// TYPES
import { ReducerActionRotaSP } from 'store/modules/types';

import { PATH_SGU_API } from 'services/rotasp/path';
import { IncluirRequest, Types } from './types';

// ACTIONS
import {
	estatisticaIncluirSuccess,
	estatisticaIncluirFailure,
} from './actions';

function* estatisticaIncluirRequest(
	request: ReducerActionRotaSP,
): Generator<any, void, any> {
	const { token, payload }: { token?: string; payload: IncluirRequest } =
		request;

	const idUsuarioAutenticado = yield select(
		state => state.api.sgu.loginUnico.user.idUsuario,
	);

	const newPayload: any = { ...payload };

	newPayload.flagConfronto = newPayload.flagConfronto !== 'N';

	const response: ApiResponse = yield call(
		postApi,
		token || '',
		PATH_SGU_API,
		`estatisticas`,
		newPayload,
		{ idUsuarioAutenticado },
	);

	if (response.status === 200 || response.status === 201) {
		yield put(estatisticaIncluirSuccess(response));
	} else {
		yield put(estatisticaIncluirFailure(response.message));
	}
}

export default all([
	takeLatest(Types.ESTATISTICA_INCLUIR_REQUEST, estatisticaIncluirRequest),
]);
